import { render, staticRenderFns } from "./AnchorDashboard.vue?vue&type=template&id=7019ccbe"
import script from "./AnchorDashboard.vue?vue&type=script&lang=js"
export * from "./AnchorDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/stage.cashnow.d-resources.com/releases/67404460/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7019ccbe')) {
      api.createRecord('7019ccbe', component.options)
    } else {
      api.reload('7019ccbe', component.options)
    }
    module.hot.accept("./AnchorDashboard.vue?vue&type=template&id=7019ccbe", function () {
      api.rerender('7019ccbe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/dashboard/AnchorDashboard.vue"
export default component.exports